module.exports = __webpack_public_path__ + "img/logo-ympact.da1234fb.png";